import { computed } from 'vue';
import { useOrganizationsStore } from '@/stores/organizations';
import { useAuthStore } from '@/stores/auth';

export function useOrganizationPermissions(organizationId?: string) {
  const store = useOrganizationsStore();
  const authStore = useAuthStore();

  const targetId = computed(() => organizationId || store.currentOrganizationId);

  const currentMember = computed(() => {
    const id = targetId.value;
    const userId = authStore.user?.id;
    if (!id || !userId) return null;

    return store.membersCache[id]?.find(m => m.user_id === userId) || null;
  });

  const currentRole = computed(() => currentMember.value?.role || null);

  const isOwner = computed(() => currentRole.value === 'owner');
  const isAdmin = computed(() => currentRole.value === 'admin' || currentRole.value === 'owner');
  const isMember = computed(() => !!currentRole.value);

  const canEditOrganization = computed(() => isAdmin.value);
  const canDeleteOrganization = computed(() => isOwner.value);
  const canManageMembers = computed(() => isAdmin.value);
  const canInviteMembers = computed(() => isAdmin.value);
  const canChangeRoles = computed(() => isAdmin.value);
  const canVerifyDomain = computed(() => isOwner.value);

  return {
    currentRole,
    isOwner,
    isAdmin,
    isMember,

    canEditOrganization,
    canDeleteOrganization,
    canManageMembers,
    canInviteMembers,
    canChangeRoles,
    canVerifyDomain,
  };
}
